import styled from "@emotion/styled";

import { theme } from "../../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const PopdProtocolHint = styled.div(props => ({
    marginBottom: "8px",
    padding: "0 16px 0 28px",
    color: theme(props).typography.secondary.color,
}));

export const PopdProtocolBlock = styled.div<{ hasInternalErrors: boolean; isSuccessful: boolean }>(props => {
    const backgroundColor = props.hasInternalErrors
        ? theme(props).keyPalette.panel2BackgroundColorAsBlackTransparent
        : props.isSuccessful
          ? theme(props).semanticColors.success.backgroundColor
          : theme(props).semanticColors.warning.backgroundColor;

    return {
        display: "flex",
        alignItems: "center",
        backgroundColor: backgroundColor,
        padding: "12px 16px 12px 28px",
    };
});

export const PopdProtocolInfo = styled.div({
    marginRight: "auto",
    flexGrow: 0,
});

export const PopdProtocolHeader = styled.div({
    fontWeight: "700",
});

export const PopdProtocolItem = styled.span({
    ":not(:first-of-type)": {
        marginLeft: "8px",
    },
});

export const PopdProtocolButtonWrapper = styled.span({
    marginLeft: "8px",
});
